var exports = {
  "k": "xa15a2ab7--bae821--container",
  "n": "xa15a2ab7--bae821--link",
};

module.exports = exports;
